<template>
    <div id="tracking" class="tracking" :class="{ 'tracking__active': !getMenuState }">
<!--        <div-->
<!--            class="tracking__aside-wrapper"-->
<!--            :class="{-->
<!--                'tracking__aside-wrapper&#45;&#45;active': !getMenuState && this.currentJourney-->
<!--            }"-->
<!--        >-->
            <sp-aside
                class="tracking__aside"

                :menu-state="getMenuState"
                :current-journey="currentJourney"
            >
            </sp-aside>
<!--        </div>-->
        <div class="tracking__map">
            <here-map :padding="mapPadding" ref="map">
                <div v-if="isTrackingAvailable">
                    <here-info-bubble v-for="vehicle in trackingVehicles" v-if="vehicle.vehicleTracking != null" name="test-bubble" :lat="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0" :lng="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0" :component="vehicleInfoBubble"
                        :data="{
                            id: vehicle.id,
                            status: vehicle.status,
                            registrationNumber: vehicle.registrationNumber,
                            driverName: vehicle.driverName || 'Unknown',
                            hardwareId: vehicle.trackingHardwareId,
                            latitude: vehicle.vehicleTracking.lat,
                            longitude: vehicle.vehicleTracking.lng,
                            hasStreamingDevice: deviceList.includes(vehicle.mediaHardwareId)
                        }">
                        <div>
                            <here-marker
                                :key="vehicle.id"
                                :lat="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0"
                                :lng="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0"
                                :icon="{
                                    bitmap: icons[vehicle.status],
                                    options: { anchor: { x:15, y: 0 } }
                                }"
                                :map="map"

                                is-on-click
                            ></here-marker>
                            <here-dom-marker
                                v-if="isRegistrationVisible"
                                :key="`dom-marker-${vehicle.id}`"
                                :lat="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lat: 0"
                                :lng="vehicle.vehicleTracking != null? vehicle.vehicleTracking.lng: 0"
                                :registration-number="vehicle.registrationNumber"
                                :registration-color="vehicle.status"
                            ></here-dom-marker>
                        </div>
                    </here-info-bubble>
                    <here-button @click.native="registrationToggler" :is-active="isRegistrationVisible">
                        <svg class="here-hide-img" version="1.0" xmlns="http://www.w3.org/2000/svg" width="61.000000pt" height="44.000000pt" viewBox="0 0 61.000000 44.000000" preserveAspectRatio="xMidYMid meet">
                            <g transform="translate(0.000000,44.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                <path d="M210 340 c-11 -11 -20 -24 -20 -30 0 -5 -13 -10 -30 -10 -28 0 -37 -11 -29 -35 2 -5 6 -48 9 -95 5 -84 5 -85 32 -88 22 -3 30 2 38 22 7 19 17 26 35 26 14 0 25 5 25 10 0 6 -25 10 -55 10 l-55 0 0 43 c0 32 6 49 21 63 11 10 27 33 34 52 l14 33 83 -3 c79 -3 83 -4 96 -30 10 -21 20 -28 43 -28 28 0 40 -15 18 -22 -9 -3 -9 -10 1 -27 8 -15 10 -41 6 -67 -3 -28 -2 -44 5 -44 6 0 10 25 9 63 0 34 1 73 2 87 3 21 -2 25 -27 28 -21 2 -35 12 -47 32 -17 30 -18 30 -103 30 -72 0 -88 -3 -105 -20z m-30 -70 c0 -5 -7 -10 -15 -10 -8 0 -15 5 -15 10 0 6 7 10 15 10 8 0 15 -4 15 -10z m10 -155 c0 -8 -7 -15 -15 -15 -8 0 -15 7 -15 15 0 8 7 15 15 15 8 0 15 -7 15 -15z"/>
                                <path d="M332 265 c-18 -8 -35 -21 -38 -30 -4 -10 -19 -15 -45 -15 -37 0 -39 -2 -39 -30 0 -27 3 -30 33 -30 23 0 40 -9 60 -30 23 -24 37 -30 68 -30 100 0 125 128 34 166 -40 16 -32 17 -73 -1z m85 -27 c27 -26 30 -73 6 -100 -22 -25 -84 -24 -108 2 -18 20 -17 20 37 20 40 0 57 4 62 15 12 32 -5 45 -57 45 -49 0 -50 0 -32 20 24 26 63 25 92 -2z m-137 -48 c0 -16 -7 -20 -30 -20 -23 0 -30 4 -30 20 0 16 7 20 30 20 23 0 30 -4 30 -20z m120 0 c0 -17 -7 -20 -50 -20 -43 0 -50 3 -50 20 0 17 7 20 50 20 43 0 50 -3 50 -20z"/>
                                <path d="M353 139 c11 -7 23 -7 35 0 14 9 11 10 -18 10 -29 0 -32 -1 -17 -10z"/>
                                <path d="M440 112 c0 -14 66 -73 73 -65 4 4 -7 22 -25 40 -31 32 -48 41 -48 25z"/>
                            </g>
                        </svg>
                    </here-button>
                </div>

                <here-cluster-button v-if="!isTrackingAvailable" @click.native="clusterToggler" :is-active="isClusterVisible">
                    <svg class="here-cluster-img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7zM156.3 232.2c2.2-6.9 3.5-14.2 3.7-21.7l183.8-73.5c3.6 3.5 7.4 6.7 11.6 9.5L317.6 354.1c-5.5 1.3-10.8 3.1-15.8 5.5L156.3 232.2z"/>
                    </svg>
                </here-cluster-button>

                <here-journey v-for="(journey, index) in journeys" :key="`map-${index}-${journey.id}`" :journey="journey"></here-journey>
            </here-map>
        </div>

        <sp-loader v-show="loading"></sp-loader>
    </div>
</template>

<script>
import SpAside from '@/views/Tracking/components/Aside/Aside'
import { mapGetters, mapActions } from 'vuex'
import TrackingService from '@/services/TrackingService'
import HereMap from '@/components/maps/here/HereMap'
import HereInfoBubble from '@/components/maps/here/components/HereInfoBubble'
import HereMarker from '@/components/maps/here/components/HereMarker'
import { DeviceApi, DeviceEventApi, JourneyApi, MediaRequestApi, TelemetryApi, TrackingApi, VehicleApi } from '@/api'
import VehicleTrackingTransformer from '@/transformers/VehicleTrackingTransformer'
import VehicleInfoBubble from '@/components/atoms/VehicleInfoBubble'
import moment from 'moment'
import { VehicleTransformer } from '@/transformers'
import HereJourney from '@/components/maps/here/components/HereJourney'
import { findVehicleFromGroupedVehicles } from '@/helpers/Utils'
import JourneyTelemetryExtendedTransformer from '@/transformers/JourneyTelemetryExtendedTransformer'
import toast from '@/plugins/izitoast'
import { TimelineTransformer } from '@/transformers/TimelineTransformer'
import SpLoader from '@/components/atoms/Loader'
import HereDomMarker from '@/components/maps/here/components/HereDomMarker'
import HereButton from '@/components/maps/here/components/HereButton'
import HereClusterButton from '@/components/maps/here/components/HereClusterButton'

const journeyApi = new JourneyApi()
const deviceEventApi = new DeviceEventApi()
const mediaRequestApi = new MediaRequestApi()
const trackingApi = new TrackingApi()
const telemetryApi = new TelemetryApi()
const vehicleApi = new VehicleApi()
const deviceApi = new DeviceApi()
const vehicleTransformer = new VehicleTransformer()
const vehicleTrackingTransformer = new VehicleTrackingTransformer()
const journeyTelemetryExtendedTransformer = new JourneyTelemetryExtendedTransformer()
const timelineTransformer = new TimelineTransformer()
const trackingIntervalTime = process.env.VUE_APP_TRACKING_INTERVAL_TIME || 1000 * 10

export default {
    name: 'Tracking',
    components: {
        SpLoader,
        HereJourney,
        HereMap,
        HereInfoBubble,
        HereMarker,
        SpAside,
        HereDomMarker,
        HereButton,
        HereClusterButton
    },
    async mounted () {
        this.clearSubscriptionJourneyVehicle()
        // this.clearActiveJourneys()
        this.resetStateToDefault()

        this.setEventFilters(this.eventTypes)
        this.setEventClassification(this.eventClassifications)

        const routerParams = this.$route.params
        if (null != routerParams.date && null != routerParams.journeyId && null != routerParams.vehicleId) {
            const result = await vehicleApi.getGroupedVehicles()
            const vehicle = findVehicleFromGroupedVehicles(routerParams.vehicleId, result.payload)

            if (!vehicle) {
                toast.error('Vehicle not found')
                return
            }

            if (process.env.VUE_APP_DEBUG) {
                console.debug('test', vehicle)
            }

            const dateFrom = moment(routerParams.date).startOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment(routerParams.date).endOf('d').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const [journeyResponse, eventsResponse, mediaResponse] = await Promise.allSettled([
                journeyApi.getJourneys(dateFrom, dateTo, vehicle.id),
                deviceEventApi.getDeviceEvents({
                    dateFrom,
                    dateTo,
                    vehicleId: vehicle.id
                }),
                mediaRequestApi.getMediaRequests({
                    videoTimeFrom: dateFrom,
                    videoTimeTo: dateTo,
                    hardwareId: vehicle.mediaHardwareId
                })
            ])

            const journeys = await TrackingService.transformJourneyRequest(journeyResponse.value, eventsResponse.value, mediaResponse.value, vehicle)
            this.setCurrentJourney(journeys)

            let journey = TrackingService.getJourneyListToDisplay(this.activeJourneys[0]).find((elem) => {
                if (elem.id === routerParams.journeyId) {
                    console.debug(elem)

                    return elem
                }
            })

            if (!journey) {
                toast.error('Journey not found')
                return
            }
            const telemetryResponse = await journeyApi.getJourney(journey.id, false)

            if (!result.isSuccess) {

                // TODO: throw error
            }

            journey.telemetryExtended = journeyTelemetryExtendedTransformer.transform(telemetryResponse.payload.journey)

            const timelineResponse = await journeyApi.getJourneyTimeline(journey.startPoint.utc, journey.endPoint.utc, journey.vehicleId)
            if (!timelineResponse.isSuccess) {
                toast.error('Timeline not found')
                return
            }

            console.debug('payload', timelineResponse.payload)
            journey.timeline = timelineTransformer.transform(timelineResponse.payload)

            console.debug('test', journey)

            const telemetryUnsnappedResponse = await telemetryApi.getTelemetry(journey.hardwareId, journey.startPoint.utc, journey.endPoint.utc, true)
            console.debug('telemetryResponse', telemetryUnsnappedResponse, telemetryResponse)
            journey.telemetryUnsnapped = journeyTelemetryExtendedTransformer.transform(telemetryUnsnappedResponse.payload)

            if (journey.hardwareId) {
                const deviceResponse = await deviceApi.getDevice(journey.hardwareId)

                if (deviceResponse.isSuccess) {
                    this.activeDevice = deviceResponse.payload
                }

                vehicle.deviceDetails = deviceResponse.payload
                vehicle.hardwareId = journey.hardwareId
            }

            this.setCurrentJourney(journey)
            this.addSelectedJourney(journey)
            this.setCurrentVehicle(vehicle)
            await this.setMenuAction(false)
            // this.drawJourney(journey)
            this.$refs.map.viewPort.resize()
        }
    },
    beforeDestroy() {
        clearInterval(this.trackingInterval)
    },
    data () {
        return {
            map: HereMap,
            icons: {
                'online': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#aed51b"/><g transform="translate(6.079 11.699)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
                'offline': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#fe2e58"/><g transform="translate(6.079 12.761)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>',
                'inactive': '<svg xmlns="http://www.w3.org/2000/svg" width="31.809" height="40.521" viewBox="0 0 31.809 40.521"><path d="M26.871,4.267a15.764,15.764,0,0,0-11.79-4.2A15.94,15.94,0,0,0,0,15.965c0,11.47,11.2,21.341,14.578,24.129a2.122,2.122,0,0,0,1.325.457,2.034,2.034,0,0,0,1.325-.457A53.023,53.023,0,0,0,25.637,31.5c4.2-5.438,6.261-10.785,6.169-15.812A15.585,15.585,0,0,0,26.871,4.267Z" transform="translate(0 -0.03)" fill="#fff"/><path d="M18.664,41.074C16.151,39.063,5,29.375,5,18.818A13.605,13.605,0,0,1,17.887,5.2h.823A13.557,13.557,0,0,1,32.328,18.636C32.511,29.192,21.177,39.017,18.664,41.074Z" transform="translate(-2.715 -2.838)" fill="#707070"/><g transform="translate(6.078 10.638)"><g transform="translate(0 0)"><path d="M16.75,6.593l-2.872.287a.569.569,0,0,0-.479.574.562.562,0,0,0,.526.479h.048l2.872-.287a.569.569,0,0,0,.479-.574A.5.5,0,0,0,16.75,6.593Z" transform="translate(-6.986 -3.432)" fill="#fff"/><path d="M18.954,3.779l-3.685-.957a.978.978,0,0,1-.431-.239L12.54.62A2.7,2.7,0,0,0,11.1.045L7.514,0A4.3,4.3,0,0,0,3.877,1.768l-.622.862-1.532.191A2.062,2.062,0,0,0,0,4.879V6.411A1.473,1.473,0,0,0,1.532,7.895h.383A1.613,1.613,0,0,0,2.489,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.076,2.076,0,0,0,1.1.239,2.256,2.256,0,0,0,2.2-1.675h7.371A1.613,1.613,0,0,0,14.263,8.9c.1.1.239.191.335.287.048.048.144.1.191.144a2.1,2.1,0,0,0,1.1.287,2.256,2.256,0,0,0,2.2-1.675c1.579-.048,2.345-.574,2.345-1.532v-.67A1.959,1.959,0,0,0,18.954,3.779ZM4.116,8.565A1.292,1.292,0,1,1,5.409,7.273,1.39,1.39,0,0,1,4.116,8.565Zm11.774,0a1.292,1.292,0,1,1,1.292-1.292A1.318,1.318,0,0,1,15.89,8.565Zm3.542-2.2c0,.383-.67.479-1.244.526a2.317,2.317,0,0,0-2.3-1.915,2.1,2.1,0,0,0-1.1.287.661.661,0,0,0-.191.144,2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H6.366a2.411,2.411,0,0,0-2.3-1.915,2.672,2.672,0,0,0-1.1.287c-.048,0-.1.048-.144.1a2.026,2.026,0,0,0-.335.239,1.947,1.947,0,0,0-.622,1.244H1.532a.492.492,0,0,1-.526-.479V4.832a.986.986,0,0,1,.862-1.005L3.4,3.587a1.033,1.033,0,0,0,.67-.431l.574-.766A3.344,3.344,0,0,1,7.467,1l3.59.1a1.668,1.668,0,0,1,.814.287l2.25,1.962a2.43,2.43,0,0,0,.862.431l3.685.957a1.021,1.021,0,0,1,.766,1.005Z" transform="translate(0 0.005)" fill="#fff"/></g><path d="M1.54,4.62l1.771-.814,1.2-.479.862-.67,1.2-.766L8.528,1.7h2.824a3.981,3.981,0,0,1,1.388.191c.239.191.766.766.766.766l.814.814a6.083,6.083,0,0,0,1.053.622c.239.1,1.292.335,1.292.335l1.484.383,1.1.383,1.1.909s.144.862.144,1.149-.1.383-.574.574a5.572,5.572,0,0,1-.814.287L18.1,8.449l-.526.862-.766.574a4.4,4.4,0,0,1-.814,0,10.749,10.749,0,0,1-1.34-.718,1.5,1.5,0,0,0-.574-.622A6.883,6.883,0,0,0,12.548,8.4H10.107a10.12,10.12,0,0,0-1.723-.1c-.287.1-1.34.048-1.532.1a1.489,1.489,0,0,0-.526.048C6.278,8.5,5.7,9.6,5.7,9.6a2.579,2.579,0,0,1-.814.383c-.239,0-.718.1-.957-.1s-.67-.622-.67-.622A6.392,6.392,0,0,0,2.928,8.4a6.279,6.279,0,0,1-.718-.144c-.144-.048-.862-.239-.909-.383-.048-.1-.383-.526-.239-.718S1.061,5.1,1.54,4.62Z" transform="translate(-0.535 -0.884)" fill="#fff"/></g></svg>'
            },
            vehicleInfoBubble: VehicleInfoBubble,
            trackingInterval: null,
            deviceList: [],
            isMapCenter: false,
            journeys: [],
            registrationColor: '',
            isRegistrationVisible: false,
            isClusterVisible: true
        }
    },
    computed: {
        ...mapGetters({
            getMenuState: 'layoutModule/getMenuState',
            currentJourney: 'trackingModule/getCurrentJourney',
            journeyVehicles: 'trackingModule/getJourneyVehicles',
            activeJourneys: 'trackingModule/getActiveJourneys',
            currentVehicle: 'trackingModule/getCurrentVehicle',
            trackingVehicles: 'trackingModule/getTrackingVehicles',
            selectedJourneys: 'trackingModule/getSelectedJourneys',
            eventTypes: 'dictionaryModule/getEventTypes',
            eventClassifications: 'dictionaryModule/getEventClassifications',
            getIsJourneyTabActive: 'trackingModule/getIsJourneyTabActive',
            getConnectionId: 'signalR/getConnectionId'
        }),
        mapPadding: function () {
            return {
                top: null,
                right: this.resolveRightMapOffset(this.getMenuState, this.currentJourney),
                bottom: 40,
                left: this.resolveLeftMapOffset(this.getMenuState, this.currentJourney)
            }
        },
        loading: {
            get () {
                return this.$store.state.trackingModule.isLoading
            },
            set (value) {
                this.$store.commit('trackingModule/setLoading', value)
            }
        },
        isTrackingAvailable () {
            return !this.getIsJourneyTabActive
        }
    },
    watch: {
        journeyVehicles: {
            handler () {
                if (null !== this.currentVehicle) {
                    const journey = TrackingService.findActiveJourney(this.currentVehicle)

                    this.setCurrentJourney(journey)
                }
            },
            deep: true
        },
        currentVehicle: {
            handler () {
                if (null !== this.currentVehicle) {
                    const journey = TrackingService.findActiveJourney(this.currentVehicle)

                    this.setCurrentJourney(journey)
                }
            },
            deep: true
        },
        trackingVehicles: {
            async handler (newVal, oldVal) {
                if (0 === this.trackingVehicles.length) {
                    return
                }

                this.isMapCenter = false
                this.getTracking()
            }
        },
        selectedJourneys: {
            handler () {
                if (process.env.VUE_APP_DEBUG) {
                    console.debug('DRAWING JOURNEYS', this.selectedJourneys)
                }

                this.isMapCenter = false

                this.journeys = []

                this.selectedJourneys.forEach((journey) => {
                    this.drawJourney(journey)
                })

                this.$refs.map.centerMap(() => {
                    this.isMapCenter = true
                })
            },
            deep: true
        }
    },
    methods: {
        ...mapActions({
            clearSubscriptionJourneyVehicle: 'trackingModule/clearSubscriptionJourneyVehicle',
            clearActiveJourneys: 'trackingModule/clearActiveJourneys',
            addActiveJourney: 'trackingModule/addActiveJourney',
            setCurrentJourney: 'trackingModule/setCurrentJourney',
            setCurrentVehicle: 'trackingModule/setCurrentVehicle',
            setMenuAction: 'layoutModule/setMenuAction',
            subscribeJourneyVehicle: 'trackingModule/subscribeJourneyVehicle',
            addSelectedJourney: 'trackingModule/addSelectedJourney',
            setEventFilters: 'trackingModule/setEventFilters',
            setEventClassification: 'trackingModule/setEventClassification',
            setShowIdlePoints: 'trackingModule/setShowIdlePoints',
            setShowRawData: 'trackingModule/setShowRawData',
            clearSelectedJourneys: 'trackingModule/clearSelectedJourneys',
            setIsJourneyTabActive: 'trackingModule/setIsJourneyTabActive',
            setOpenAutoJourney: 'trackingModule/setOpenAutoJourney',
            setDateInJourneyTab: 'trackingModule/setDateInJourneyTab',
            setIsClusteringActive: 'trackingModule/setIsClusteringActive'
        }),
        registrationToggler () {
            this.isRegistrationVisible = !this.isRegistrationVisible
        },
        clusterToggler () {
            this.isClusterVisible = !this.isClusterVisible
            this.setIsClusteringActive(this.isClusterVisible)
        },
        async getTracking () {
            if (process.env.VUE_APP_DEBUG) {
                console.debug('Tracking::getTracking')
            }

            const response = await trackingApi.subscribe(this.getConnectionId, this.extractHardwareIdForSubscription())

            response.payload.forEach((message) => {
                const vehicle = this.trackingVehicles.find((item) => {
                    return item.trackingHardwareId == message.hardId
                })

                if (null == vehicle) {
                    return
                }

                vehicle.vehicleTracking = vehicleTrackingTransformer.transform(message)
            })

            if (!this.isMapCenter) {
                this.$refs.map.centerMap(() => {
                    this.isMapCenter = true
                })
            }
        },
        drawJourney (journey) {
            if (null == journey.telemetryExtended || null == journey.telemetryExtended.route || 0 === journey.telemetryExtended.route.length) {
                return
            }

            this.dataLines = []

            let filtered = []
            if (1000 > journey.telemetryExtended.route.length) {
                filtered = journey.telemetryExtended.route
            } else {
                filtered = journey.telemetryExtended.route.filter((item, index) => {
                    return 0 === index % 5
                })
            }

            let journeyObject

            journeyObject = this.journeys.find((tmpJourney) => {
                return tmpJourney.id === journey.id
            })

            if (!journeyObject) {
                // let startPoint = journey.startPoint
                let startPoint = {
                    lat: journey.startPoint.lat || filtered[0].lat,
                    lng: journey.startPoint.lng || filtered[0].lng
                }

                // let endPoint = journey.endPoint
                let endPoint = {
                    lat: journey.endPoint.lat || filtered[filtered.length - 1].lat,
                    lng: journey.endPoint.lng || filtered[filtered.length - 1].lng
                }

                let idlePts = []

                if (journey.telemetryExtended.idlePoints != null) {
                    idlePts = journey.telemetryExtended.idlePoints.filter((item) => {
                        return null != item.lat && null != item.lng
                    })
                }

                journeyObject = {
                    id: journey.id,
                    startPoint: startPoint,
                    endPoint: endPoint,
                    dataLines: [],
                    rawData: [],
                    events: journey.events,
                    idles: idlePts,
                    limits: [],
                    rawLimits: [],
                    speeding: [],
                }

                this.journeys.push(journeyObject)
            }

            // eslint-disable-next-line no-undef
            this.hitArea = new H.map.HitArea(H.map.HitArea.ShapeType.CIRCLE, [1, 1, 1])

            let limitPoints = journey.telemetryExtended.route
            let rawLimitPoints = journey.telemetryUnsnapped.route || []

            limitPoints.forEach((item, index) => {
                if (null != item.lat && null != item.lng && null != item.utc) {
                    journeyObject.limits.push({
                        id: `${item.utc}-${item.lng}-${item.lat}-${index}`,
                        status: item.status || 'unknown',
                        registrationNumber: this.currentVehicle.registrationNumber || 'unknown',
                        driverName: this.currentVehicle.driverName,
                        latitude: item.lat,
                        longitude: item.lng,
                        speedLimit: Math.round(item.speedLimitInKph || 0),
                        speed: Math.round(item.speedInKph || 0),
                        heading: item.headingMatched || 0,
                        date: item.utc,
                        hardwareId: journey.hardwareId,
                        isHardwareOnline: this.currentVehicle && this.currentVehicle.isHardwareOnline
                            ? this.currentVehicle.isHardwareOnline
                            : false
                    })
                }
            })

            rawLimitPoints.forEach((item, index) => {
                if (null != item.lat && null != item.lng && null != item.utc) {
                    journeyObject.rawLimits.push({
                        id: `${item.utc}-${item.lat}-${item.lng}-${index}`,
                        status: item.status || 'unknown',
                        registrationNumber: this.currentVehicle.registrationNumber || 'unknown',
                        driverName: this.currentVehicle.driverName,
                        latitude: item.lat,
                        longitude: item.lng,
                        speedLimit: Math.round(item.speedLimitInKph || 0),
                        speed: Math.round(item.speedInKph || 0),
                        heading: item.headingMatched || 0,
                        date: item.utc,
                        hardwareId: journey.hardwareId,
                        isHardwareOnline: this.currentVehicle && this.currentVehicle.isHardwareOnline
                            ? this.currentVehicle.isHardwareOnline
                            : false
                    })
                }
            })

            this.dataLines = []

            filtered.forEach((extendedRoute) => {
                journeyObject.dataLines.push(new H.geo.Point(extendedRoute.lat, extendedRoute.lng))
            })

            if (journey.telemetryUnsnapped.route != null) {
                journey.telemetryUnsnapped.route.forEach((extendedRoute) => {
                    journeyObject.rawData.push(new H.geo.Point(extendedRoute.lat, extendedRoute.lng))
                })
            }

            if (journey.telemetryExtended.journeySpeedPoints != null) {
                journey.telemetryExtended.journeySpeedPoints.forEach((speedBlock) => {
                    let speedingPoints = []
                    speedBlock.points.forEach((point) => {
                        speedingPoints.push(new H.geo.Point(point.lat, point.lng))
                    })

                    speedBlock.dataLines = speedingPoints
                    journeyObject.speeding.push(speedBlock)
                })
            }
        },
        extractHardwareIdForSubscription () {
            const hardwareId = []

            this.trackingVehicles.map((vehicle) => {
                hardwareId.push(vehicle.trackingHardwareId)
            })

            return hardwareId
        },
        // only for debug purpose
        async getJourneys (vehicleId, mediaHardwareId, subtractDays = 0) {
            await this.setMenuAction(false)

            const vehicleResponse = vehicleApi.getVehicle(vehicleId)
            const vehicle = vehicleTransformer.transform(vehicleResponse)

            const dateFrom = moment(this.dateString).startOf('d').subtract(subtractDays, 'd').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'
            const dateTo = moment(this.dateString).endOf('d').subtract(subtractDays, 'd').format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z'

            const [journeyResponse, eventsResponse, mediaResponse] = await Promise.allSettled([
                journeyApi.getJourneys(dateFrom, dateTo, vehicleId),
                deviceEventApi.getDeviceEvents({
                    dateFrom,
                    dateTo,
                    vehicleId: vehicleId
                }),
                mediaRequestApi.getMediaRequests({
                    videoTimeFrom: dateFrom,
                    videoTimeTo: dateTo,
                    hardwareId: mediaHardwareId
                })
            ])

            // TODO: error handling to discuss

            TrackingService.transformJourneyRequest(journeyResponse.value, eventsResponse.value, mediaResponse.value, vehicle)

            await this.subscribeJourneyVehicle(vehicle)
        },
        resolveRightMapOffset (isMenuStateActive, isCurrentJourney) {
            if (isCurrentJourney) {
                return 0
            } else if (isMenuStateActive) {
                return 0
            }
            return null
        },
        resolveLeftMapOffset (isMenuStateActive, isCurrentJourney) {
            if (isCurrentJourney) {
                return 500
            } else if (isMenuStateActive) {
                return 0
            }
            return null
        },
        resetStateToDefault () {
            this.setShowIdlePoints(true)
            this.setShowRawData(false)
            this.clearActiveJourneys()
            this.setCurrentJourney(null)
            this.clearSelectedJourneys()
            this.setCurrentVehicle(null)
            this.setIsJourneyTabActive(false)
            this.setOpenAutoJourney(true)
            this.setDateInJourneyTab(moment().format('YYYY-MM-DD'))
        }
    }
}
</script>

<style scoped lang="scss">
.tracking {
    display: flex;
    flex-direction: row;
    position: relative;
    //margin-left: -202px;
    width: 100%;

    //&__aside-wrapper {
    //    width: 0px;
    //    transition: width .3s ease-in-out;
    //    will-change: width;
    //    //min-width: 450px;
    //    &--active {
    //        width: 500px;
    //    }
    //}

    &__aside {
        position: absolute;
        background-color: white;
        top: 0px;
        left: 0px;
        z-index: 4;
        display: flex;
        flex-direction: row;
        width: 600px;
    }

    &__active {
        //margin-left: 0px;
    }

    &__map {
        width: 100%;
    }
}
</style>
